import React from 'react';
import { Tooltip } from '../../../../../tooltip/tooltip';
import { ValueAmount } from '../../../../../value/amount/value-amount';
import { ValuePercents } from '../../../../../value/percents/value-precents';
import { CardDashboardTradesDividendsDivider } from '../divider/card-dashboard-trades-dividends-divider';
import { CardDashboardTradesDividendsRow } from '../row/card-dashboard-trades-dividends-row';
import { CardDashboardTradesDividendsSection } from '../section/card-dashboard-trades-dividends-section';

interface CardDashboardTradesDividendsContentProps {
    dividendsYield: number;
    dividendsYieldOnCost: number;
    dividendsNextYearPrediction: number;
    dividends: number;
    currency: string;
    yieldLabel: string;
    yieldOnCostLabel: string;
    predictionLabel: string;
    predictionTooltip: string;
    payoutLabel: string;
}

export const CardDashboardTradesDividendsContent: React.FC<CardDashboardTradesDividendsContentProps> = ({
    dividendsYield,
    dividendsYieldOnCost,
    dividendsNextYearPrediction,
    dividends,
    currency,
    yieldLabel,
    yieldOnCostLabel,
    predictionLabel,
    predictionTooltip,
    payoutLabel,
}) => (
    <div className="flex flex-col md:flex-row md:items-center md:gap-small">
        <CardDashboardTradesDividendsSection>
            <CardDashboardTradesDividendsRow>
                <CardDashboardTradesDividendsRow strong>
                    <ValuePercents amount={dividendsYield} mode="pure" />
                </CardDashboardTradesDividendsRow>
                {yieldLabel}
            </CardDashboardTradesDividendsRow>
            <CardDashboardTradesDividendsRow>
                <CardDashboardTradesDividendsRow strong>
                    <ValuePercents amount={dividendsYieldOnCost} mode="pure" />
                </CardDashboardTradesDividendsRow>
                {yieldOnCostLabel}
            </CardDashboardTradesDividendsRow>
        </CardDashboardTradesDividendsSection>

        <CardDashboardTradesDividendsDivider />

        <CardDashboardTradesDividendsSection>
            <CardDashboardTradesDividendsRow>
                <Tooltip position="bottom-right" icon content={predictionTooltip}>
                    {predictionLabel}
                </Tooltip>
            </CardDashboardTradesDividendsRow>
            <CardDashboardTradesDividendsRow strong>
                <ValueAmount amount={dividendsNextYearPrediction} currency={currency} mode="pure" hidable />
            </CardDashboardTradesDividendsRow>
        </CardDashboardTradesDividendsSection>

        <CardDashboardTradesDividendsDivider />

        <CardDashboardTradesDividendsSection>
            <CardDashboardTradesDividendsRow>{payoutLabel}</CardDashboardTradesDividendsRow>
            <CardDashboardTradesDividendsRow large>
                <ValueAmount amount={dividends} currency={currency} mode="pure" hidable />
            </CardDashboardTradesDividendsRow>
        </CardDashboardTradesDividendsSection>
    </div>
);
